/**
* @copyright Copyright (c) MITSUBISHI Electric Corporation. All rights reserved.
*/

import React, { useState, useContext, useRef } from 'react';
import validate from 'validate.js'
import { IndexContext } from '../IndexProvider';
import PAGES from '../consts/pages';

const usernameConstraints = {
    username: {
        presence: {
            allowEmpty: false
        },
        email: true
    }
};

export default function ResetPasswordGenerateCode() {
    const [username, setUsername] = useState("");
    const [isUsernameValid, setIsUsernameValid] = useState(false)
    const [shouldShowUsernameFeedback, setShouldShowUsernameFeedback] = useState(false)
    const [isPending, setIsPending] = useState(false)

    const { pageLoading, setCurrentPage, generateConfirmCode, setCurrentChangeAccountId } = useContext(IndexContext)

    const onSubmit = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (validate({ username: username }, usernameConstraints)) {
            setIsUsernameValid(false)
        } else {
            setIsUsernameValid(true)
            setIsPending(true)
            setCurrentChangeAccountId(username)
            await generateConfirmCode(username)
            setIsPending(false)
        }
    };

    const onUsernameChange = (event) => {
        setUsername(event.target.value)
        setShouldShowUsernameFeedback(true)
        if (validate({ username: event.target.value }, usernameConstraints)) {
            setIsUsernameValid(false)
        } else {
            setIsUsernameValid(true)
        }
    }

    const buildFormControlClasses = (shouldShowFeedback, isValid) => {
        if (shouldShowFeedback) {
            return `form-control ${isValid ? "is-valid" : "is-invalid"}`
        } else {
            return "form-control"
        }
    }

    const createMainElement = (isSkeleton) => {
        const firstDiv =
            <div className={"mb-3 d-flex justify-content-center align-items-center" + (isSkeleton ? " skeleton-1" : "")} style={{ backgroundColor: "#0073e6", fontSize: 24, fontWeight: "bold", color: "#fff" }}>
                <label style={{ marginBottom: 0, visibility: isSkeleton ? "hidden" : "visible" }}>検証コード発行</label>
            </div>

        const secondDiv =
            <div className={"mb-3" + (isSkeleton ? " skeleton-1" : "")}>
                <label htmlFor="emailInput">メールアドレス</label>
                {
                    isSkeleton ? <input className="form-control" style={{ visibility: "hidden" }} /> : <input className={buildFormControlClasses(shouldShowUsernameFeedback, isUsernameValid)} onChange={onUsernameChange} value={username} type="email" id="emailInput" required />
                }
                <div className="invalid-feedback">
                    有効なメールアドレスを入力してください。
                </div>
            </div>

        const thirdDiv =
            <div className={"d-flex align-items-center justify-content-between" + (isSkeleton ? " skeleton-1" : "")} >
                {
                    isSkeleton ?
                        <>
                            <button className="btn btn-primary" style={{ visibility: "hidden" }} >skeleton</button>
                            <a style={{ visibility: "hidden" }}>skeleton</a>
                        </>
                        :
                        <>
                            <button className="btn btn-primary" type="submit" >
                                {isPending ? "発行中..." : "発行"}
                            </button>
                            <a style={{ cursor: "pointer", fontSize: 12 }} onClick={(e) => {
                                setCurrentPage(PAGES.LOGIN)
                            }} >ログイン</a>
                        </>
                }
            </div>

        return (
            <>
                {firstDiv}
                {secondDiv}
                {thirdDiv}
            </>
        )
    }

    return (
        pageLoading ?
            <>
                <div className="d-flex justify-content-center align-items-center ps-3 pe-3 pt-5 pb-5">
                    <div className="w-100 form-container p-3 " style={{ border: "1px solid #fff", backgroundColor: "#fbfafa" }} >
                        {createMainElement(true)}
                    </div>
                </div>
            </>
            :
            <>
                <div className="d-flex justify-content-center align-items-center ps-3 pe-3 pt-5 pb-5">
                    <form noValidate className="w-100 form-container p-3" style={{ border: "1px solid #0073e6" }} onSubmit={onSubmit} >
                       {createMainElement()}
                    </form>
                </div>
            </>
    );
}